// Parsing dates with dayjs with the format option requires the date to match the format exactly.
// For example parsing 1/8/2021 with format option 'MM/DD/YYYY' will result in an 'Invalid Date'.
// We use an array of formats which is a subset of the format to match all valid cases.
// Note: Because we use strict = true in parsing dayjs dates, we include formats for '/', '.', and '-'
// delimiters so that 1.8.2021 and 12-24-23 will still match the 'MM/DD/YYYY' set.
const dateFormats = {
    'MM/DD/YYYY': [
        'MM/DD/YYYY',
        'MM/D/YYYY',
        'M/DD/YYYY',
        'M/D/YYYY',
        'MM/DD/YY',
        'MM/D/YY',
        'M/DD/YY',
        'M/D/YY',
        'YYYY-MM-DD',
        'MM.DD.YYYY',
        'MM.D.YYYY',
        'M.DD.YYYY',
        'M.D.YYYY',
        'MM.DD.YY',
        'MM.D.YY',
        'M.DD.YY',
        'M.D.YY',
        'MM-DD-YYYY',
        'MM-D-YYYY',
        'M-DD-YYYY',
        'M-D-YYYY',
        'MM-DD-YY',
        'MM-D-YY',
        'M-DD-YY',
        'M-D-YY',
        'MMDDYYYY',
    ],
    'MM/DD': [
        'MM/DD',
        'M/DD',
        'MM/D',
        'M/D',
        'MM.DD',
        'M.DD',
        'MM.D',
        'M.D',
        'MM-DD',
        'M-DD',
        'MM-D',
        'M-D',
        'MMDD',
        'YYYY-MM-DD',
    ],
    'MM/YY': ['MM/YY', 'M/YY', 'MM.YY', 'M.YY', 'MM-YY', 'M-YY', 'MMYY'],
    'MM/YYYY': [
        'MM/YYYY',
        'M/YYYY',
        'MM/YY',
        'M/YY',
        'MM.YYYY',
        'M.YYYY',
        'MM.YY',
        'M.YY',
        'MM-YYYY',
        'M-YYYY',
        'MM-YY',
        'M-YY',
        'MMYYYY',
        'MMYY',
        'YYYY-MM-DD',
    ],
    MMYY: ['MMYY'],
};

/**
 * Generated bundle index. Do not edit.
 */

export { dateFormats };
